import { Suspense, lazy } from 'react';
import { DateRangePickerProps } from './DateRangePicker.types';

const DateRangePicker = lazy(() => import('./DateRangePicker'));

const LazyDateRangePicker = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  disabled,
  buttonClasses,
  shortcuts,
}: DateRangePickerProps) => (
  <Suspense fallback={null}>
    <DateRangePicker
      setEndDate={setEndDate}
      startDate={startDate}
      endDate={endDate}
      setStartDate={setStartDate}
      disabled={disabled}
      buttonClasses={buttonClasses}
      shortcuts={shortcuts}
    />
  </Suspense>
);

export default LazyDateRangePicker;
